import { hotjar } from "react-hotjar"

import { IS_PRODUCTION } from "@/lib/env"

if (typeof window !== "undefined") {
  hotjar.initialize({
    id: IS_PRODUCTION ? 3144081 : 3143543,
    sv: 6,
  })
}

export { hotjar }
